import Full from '@/containers/full'

// Payments
const PendingPayments = () => import('@/views/payments/pending-payments')
const OXXOPayment = () => import('@/views/payments/oxxo-payment')
const SPEIPayment = () => import('@/views/payments/spei-payment')
const CreditCardPayment = () => import('@/views/payments/credit-card-payment')
const AddCard = () => import('@/views/cards/add-card')

export default {
  path: '/',
  component: Full,
  redirect: '/payments',
  meta: {
    auth: true
  },
  children: [
    {
      path: '/payments',
      redirect: '/payments/pending',
      name: 'payments',
      meta: {
        auth: true
      },
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '',
          redirect: '/payments/pending'
        },
        {
          path: 'pending',
          name: 'pending-payments',
          component: PendingPayments
        },
        {
          path: 'cards/add',
          name: 'add-card',
          component: AddCard
        },
        {
          path: 'pay',
          name: 'pay',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'oxxo',
              name: 'oxxo-payment',
              component: OXXOPayment
            },
            {
              path: 'spei',
              name: 'spei-payment',
              component: SPEIPayment
            },
            {
              path: 'credit-card',
              name: 'credit-card-payment',
              component: CreditCardPayment
            }
          ]
        }
      ]
    }
  ]
}
